import { resetUploader } from '../../redux/thunks';

export function ResetButton() {
  return (
    <button id="#reset" className="text-center button btn-block red" onClick={resetUploader}>
      Reset
    </button>
  );
}

export default ResetButton;
